import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Crown, Check, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

const FEATURE_LABELS = {
  online_booking: "Prenotazione online",
  featured: "In evidenza nei risultati (badge PRO)",
  video_consult: "Video-consulti",
  priority_support: "Supporto prioritario",
};
function proposalsLabel(n) { return n < 0 ? "Proposte illimitate" : `Fino a ${n} proposte attive`; }

export default function ProSubscription() {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");
  const load = async () => { try { const { data } = await api.get("/professional/subscription"); setData(data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };
  useEffect(() => {
    load();
    const s = new URLSearchParams(location.search).get("sub_session");
    if (s) {
      let n = 0;
      const poll = async () => {
        n += 1;
        try { const { data } = await api.get(`/payments/status/${s}`); if (data.payment_status === "paid") { toast.success("Abbonamento attivato!"); load(); window.history.replaceState({}, "", "/pro/subscription"); return; } } catch {}
        if (n < 6) setTimeout(poll, 2000); else { window.history.replaceState({}, "", "/pro/subscription"); load(); }
      };
      poll();
    }
    /* eslint-disable-next-line */
  }, []);

  const select = async (planId) => {
    setBusy(planId);
    try {
      const { data } = await api.post("/professional/subscription/select", { plan: planId, origin_url: window.location.origin });
      if (data.checkout_url) { window.location.href = data.checkout_url; return; }
      toast.success("Piano aggiornato"); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  const cancel = async () => { if (!window.confirm("Tornare al piano Base gratuito?")) return; setBusy("cancel"); try { await api.post("/professional/subscription/cancel"); toast.success("Sei tornato al piano Base"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(""); } };

  if (!data) return <div className="text-zinc-500 py-10 flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Caricamento…</div>;
  const current = data.plan;

  return (
    <div className="max-w-4xl space-y-5">
      <div className="text-sm text-zinc-300">Piano attuale: <b data-testid="current-plan" className="text-[#00E676] uppercase">{current}</b>. Le funzioni premium sbloccano più visibilità e strumenti.</div>
      <div className="grid sm:grid-cols-3 gap-4">
        {data.plans.map((pl) => {
          const active = pl.id === current;
          return (
            <div key={pl.id} data-testid={`plan-${pl.id}`} className={`rounded-2xl border p-5 flex flex-col ${active ? "border-[#00E676] bg-[#00E676]/5" : "border-white/10 bg-[#1C1C1F]"}`}>
              <div className="flex items-center gap-2">
                {pl.id !== "base" && <Crown className="h-4 w-4 text-amber-300" />}
                <span className="font-['Unbounded'] font-bold">{pl.name}</span>
              </div>
              <div className="mt-2 text-2xl font-black">{pl.price_month === 0 ? "Gratis" : `€${pl.price_month}`}<span className="text-sm font-normal text-zinc-400">{pl.price_month === 0 ? "" : "/mese"}</span></div>
              <ul className="mt-4 space-y-2 text-sm flex-1">
                <li className="flex items-center gap-2 text-zinc-300"><Check className="h-4 w-4 text-[#00E676]" /> {proposalsLabel(pl.features.max_active_proposals)}</li>
                {Object.entries(FEATURE_LABELS).map(([k, label]) => (
                  <li key={k} className={`flex items-center gap-2 ${pl.features[k] ? "text-zinc-300" : "text-zinc-600"}`}>
                    {pl.features[k] ? <Check className="h-4 w-4 text-[#00E676]" /> : <X className="h-4 w-4" />} {label}
                  </li>
                ))}
              </ul>
              <div className="mt-4">
                {active ? (
                  current === "base"
                    ? <div className="text-center text-xs text-zinc-400">Piano attivo</div>
                    : <Button data-testid="plan-cancel" onClick={cancel} disabled={busy === "cancel"} variant="ghost" className="w-full text-zinc-400 hover:text-white">Torna a Base</Button>
                ) : (
                  <Button data-testid={`select-plan-${pl.id}`} onClick={() => select(pl.id)} disabled={busy === pl.id || (!pl.available && pl.price_month > 0)}
                    className={`w-full ${pl.id === "base" ? "bg-white/10 hover:bg-white/20" : "bg-[#00E676] text-black font-semibold"}`}>
                    {busy === pl.id ? "…" : pl.id === "base" ? "Passa a Base" : (!pl.available ? "Presto disponibile" : `Attiva ${pl.name}`)}
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="text-xs text-zinc-500">I pagamenti sono gestiti in sicurezza tramite Stripe. Puoi cambiare o annullare il piano in qualsiasi momento.</div>
    </div>
  );
}
